import { useState } from "react"
import { FileUploader } from "react-drag-drop-files"
import { useTranslation } from "react-i18next"
import {
  IconCompletedFile,
  IconDeleteFile,
  IconLoadFile,
  IconisLoadingFile,
} from "../utils/Icons/CustomIcons"

import { useAppDispatch, useAppSelector } from "../../redux/store"
import {
  deleteFileEvent,
  loadFileEvent,
} from "../../redux/slices/events/eventsSlice"
import {
  storeFileLocally,
  deleteFileLocally,
} from "../../redux/slices/localFileStore/localFileStore"

interface iFile {
  name: string
  size: number
  type: string
}

const ChooseFileEvent = ({
  isButton = false,
  error2,
}: {
  isButton?: boolean
  error2: any
}) => {
  const { t } = useTranslation()
  const { new_event_img, new_event_id } = useAppSelector(
    (state) => state.events,
  )
  const dispatch = useAppDispatch()

  let timer: any = null
  const [file, setFile] = useState<iFile | null>(null)
  const [error, setError] = useState(false)
  const [progress, setProgress] = useState(0)
  const [loading, setLoading] = useState(false)

  const clearFile = (id: any) => {
    dispatch(deleteFileEvent(id))
    dispatch(deleteFileLocally())

    clearInterval(timer)
    setProgress(0)
    setFile(null)
    setError(false)
    setLoading(false)
  }

  const handleError = () => {
    clearInterval(timer)
    setProgress(0)
    setError(true)
    setLoading(false)
  }

  const handleChange = (file: iFile) => {
    const formData: any = new FormData()
    let { name, size, type } = file

    size = Number((size / 1024).toFixed(0))
    formData.append("file", file)

    setLoading(true)

    timer =
      !timer &&
      setInterval(() => {
        setProgress((prevProgress) => prevProgress + 10)
      }, Number((size / 10).toFixed(0)))

    setTimeout(() => {
      clearInterval(timer)
      setProgress(100)
      setLoading(false)
    }, size)
    dispatch(storeFileLocally(file))
    dispatch(loadFileEvent(formData))

    setError(false)
    setFile(file)
  }

  return (
    <>
      {!file ? (
        <div className={`loadFile ${error || (error2 && "error")}`}>
          <FileUploader
            name="file"
            maxSize={5}
            types={["JPEG", "JPG", "PNG"]}
            multiple={false}
            handleChange={handleChange}
            onTypeError={handleError}
            onSizeError={handleError}
            required={true}
          >
            <div className="loadFile-text">
              <IconLoadFile />
              <span className="title">
                {t("eventEdit.dragAndDropOrChooseFileToUploadEventImage")}
              </span>
              <span className="desc">
                {t("eventEdit.allowedImageFormatsAreJpgPngJpegUpTo5Mb")}
              </span>
              <span className={`text-required ${error2 ? "error2" : ""}`}>
                {t("eventEdit.needToUploadAFile")}
              </span>
              {error && (
                <span className="error">
                  {t(
                    "eventEdit.theFormatAndSizeOfTheUploadedFileExceedsThePermissibleValue",
                  )}
                </span>
              )}

              {isButton && <span className="btn btn-dark">Upload File</span>}
            </div>
          </FileUploader>
        </div>
      ) : (
        <div className="loadFileComplated">
          {loading ? (
            <IconisLoadingFile />
          ) : (
            <button
              className="btn-detele-file"
              onClick={() => {
                clearFile(new_event_img.id)
              }}
            >
              <IconDeleteFile />
            </button>
          )}
          <div className="loadFileComplated__left">
            <span className="name">{file?.name}</span>
            <span className="size">{(file?.size / 1024).toFixed(0)}KB</span>
            <span className="file-status">
              {loading
                ? `${(
                    Number((file.size / 1024 / 1024).toFixed(0)) -
                    progress / 100
                  ).toFixed(0)} seconds left`
                : "Done"}
            </span>
          </div>
          <div className="loadFileComplated__right">
            <span
              className={`percent ${progress < 100 && progress > 0 && "load"}`}
            >{`${progress}%`}</span>
            {!loading && <IconCompletedFile />}
          </div>
          <div className="loadFileProgress">
            <div
              className={loading ? "progress" : "progress progress--load"}
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
      )}
    </>
  )
}

export default ChooseFileEvent
